export class GetProfileSearchData {
  static readonly type = "[ProfileSearch] Get profile search data";
  constructor(public name: string) {}
}

export class ResetProfileSearchData {
  static readonly type = "[ProfileSearch] Reset profile search data";
}
